"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _alert = _interopRequireDefault(require("./alert.js"));
var _Modal = _interopRequireDefault(require("./Modal.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var _default = exports["default"] = function _default(options) {
  if (typeof options === 'string') {
    options = {
      message: options
    };
  }
  var wrapper = document.getElementById('cccisd-notification-wrapper');
  if (!wrapper) {
    wrapper = document.body.appendChild(document.createElement('div'));
    wrapper.id = 'cccisd-notification-wrapper';
    wrapper.className = _style["default"].wrapper;
  }
  var target = wrapper.appendChild(document.createElement('div'));
  var cleanup = function cleanup() {
    _reactDom["default"].unmountComponentAtNode(target);
    setTimeout(function () {
      target.remove();
    });
  };
  if (options.inModal) {
    _reactDom["default"].render(/*#__PURE__*/_react["default"].createElement(_Modal["default"], _extends({}, options, {
      cleanup: cleanup
    })), target);
  } else {
    _reactDom["default"].render(/*#__PURE__*/_react["default"].createElement(_alert["default"], _extends({}, options, {
      cleanup: cleanup
    })), target);
  }
};